import { useMutation } from "@apollo/client";
import { create, show, useModal } from "@ebay/nice-modal-react";

import FlashContext from "components/FlashMessages/FlashContext";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useTypedContext from "hooks/useTypedContext";

import { REFETCH_QUERIES_LIST } from "./constants";
import { DELETE_DEPLOYMENT } from "./gql";

type DeleteConfirmationProps = {
  name: string;
  id: string;
  blueprintID: string;
  onDelete?: () => void;
};

const DeleteConfirmation = create(function DeleteConfirmation({
  name,
  id,
  blueprintID,
  onDelete,
}: DeleteConfirmationProps) {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const modal = useModal();

  const [deleteDeployment, { loading, data }] = useMutation(DELETE_DEPLOYMENT, {
    refetchQueries: REFETCH_QUERIES_LIST,
    awaitRefetchQueries: true,
    variables: { blueprintID, id },
  });

  const handleDeleteDeployment = () => {
    deleteDeployment()
      .then(() => {
        reportSuccess({
          message: `Deployment "${name}" has been queued for deletion`,
        });
        modal.resolve();
        modal.hide();
        onDelete?.();
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete deployment"
      onConfirm={handleDeleteDeployment}
      isLoading={loading}
      isDismissable={!loading && !data?.blueprintDeploymentDelete?.id}
    >
      <ConfirmationModalMessage>
        Are you sure you want to delete deployment <strong>{name}</strong>?
        <br />
        This action cannot be undone.
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(DeleteConfirmation, props);
